export default "__VITE_ASSET__CXRVlcAU__"